module.exports = __webpack_public_path__ + "media/images/new_landing/hp/david-kratky-6054d2e1f9699efc96cdd0fded78258c.png";